import {Triangle} from "./geometry"

const schema = 'http://www.w3.org/2000/svg'

/**
 * Create an SVG element pre-populated with a sierpinski pattern described by the input triangles.
 */
export const createSvg = (triangles: Array<Triangle>): SVGSVGElement => {
    const svg = document.createElementNS(schema, 'svg')
    svg.setAttribute('preserveAspectRatio', 'xMidYMid')

    triangles.forEach(({top, left, right}: Triangle): void => {
        const polygon: SVGPolygonElement = document.createElementNS(schema, 'polygon')
        polygon.setAttribute('points', `${top[0]},${top[1]} ${left[0]},${left[1]} ${right[0]},${right[1]}`)
        polygon.setAttribute('fill', 'black')
        svg.appendChild(polygon)
    })

    return svg
}



// WEBPACK FOOTER //
// ./src/svg.ts